import ObjectValidator from 'ember-model-validator/decorators/object-validator';

export default ObjectValidator;
